import type { ProcessStepRecording } from '@bliks-io/contracts';

export type FinishValidators = {
  hasRequiredInput: (r: ProcessStepRecording) => boolean;
  hasValidTaskDescription: (r: ProcessStepRecording) => boolean;
  hasValidSuccessors: (r: ProcessStepRecording) => boolean;
  hasValidDecisionRules: (r: ProcessStepRecording) => boolean;
  hasValidOutput: (r: ProcessStepRecording) => boolean;
};

export function getDisabledReasons(
  recording: ProcessStepRecording | null,
  validators: FinishValidators
): string[] {
  if (!recording) return [];

  if (!recording.actionType) {
    return ['recording.finishDisabled.missingActionType'];
  }

  const reasons: string[] = [];
  if (!validators.hasRequiredInput(recording)) {
    reasons.push('recording.finishDisabled.missingInput');
  }

  if (recording.actionType === 'task') {
    if (!validators.hasValidTaskDescription(recording)) {
      reasons.push('recording.finishDisabled.missingTaskDescription');
    }
    if (!validators.hasValidSuccessors(recording)) {
      reasons.push('recording.finishDisabled.missingSuccessor');
    }
    if (!validators.hasValidOutput(recording)) {
      reasons.push('recording.finishDisabled.missingOutput');
    }
  } else if (recording.actionType === 'decision') {
    if (!validators.hasValidDecisionRules(recording)) {
      reasons.push('recording.finishDisabled.missingDecisionRule');
    }
  }

  return reasons;
}
